import { InvoiceProcessingToolPanel } from "../InvoiceProcessingToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingProcessing extends Layout {
    layoutToolPanel: InvoiceProcessingToolPanel;
    panelSecondaryFilters: Panel;
    sourceBillingComments: DataSource;
    sourceInvoiceProcessingCache: DataSource;
    tableProcessing: Table;
}
